import {Component, OnInit, Input } from '@angular/core';
import { CodeScannerModel } from '../code-scanner.model';

@Component({
    selector: 'abw-code-scanner-result',
    templateUrl: './code-scanner-result.component.html',
    styleUrls: ['./code-scanner-result.component.scss']
})
export class CodeScannerResultComponent implements OnInit {
	@Input() model: CodeScannerModel;
    @Input() value: any;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}